/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RoofCoveringEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

export const RoofCoveringEnum = {
    NUMBER_1: 1 as RoofCoveringEnum,
    NUMBER_2: 2 as RoofCoveringEnum,
    NUMBER_3: 3 as RoofCoveringEnum,
    NUMBER_4: 4 as RoofCoveringEnum,
    NUMBER_5: 5 as RoofCoveringEnum,
    NUMBER_6: 6 as RoofCoveringEnum,
    NUMBER_7: 7 as RoofCoveringEnum,
    NUMBER_8: 8 as RoofCoveringEnum,
    NUMBER_9: 9 as RoofCoveringEnum,
    NUMBER_10: 10 as RoofCoveringEnum
};

